export const fontWeight = [
    { label: 'Thin', value: '100' },
    { label: 'Extra Light', value: '200' },
    { label: 'Light', value: '300' },
    { label: 'Normal', value: '400' },
    { label: 'Medium', value: '500' },
    { label: 'Semi Bold', value: '600' },
    { label: 'Bold', value: '700' },
    { label: 'Extra Bold', value: '800' },
    { label: 'Black', value: '900' },
];
export const fontFamily = [
    'Arial',
    'Helvetica',
    'Times New Roman',
    'Georgia',
    'Verdana',
    'Courier New',
    'Tahoma',
    'Trebuchet MS',
    'Lucida Sans Unicode',
    'Palatino Linotype',
    'Garamond',
    'Comic Sans MS',
    'Impact',
    'Segoe UI',
    'Franklin Gothic Medium',
    'Gill Sans',
    'Century Gothic',
    'Monaco',
    'Arial Black',
    'Candara',
    'Popins',
];
